module.exports = __webpack_public_path__ + "img/home-bg-2.ca1c8ab9.png";